import { Tag } from 'antd';
import { IRestColumnProps } from 'components/rest/Table/TableColumn';
import { ACTIVE_STATUS } from 'constants/constants';
import RestList from 'containers/rest/List';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { DynamicObjectType } from 'types/commons';

const breadcrumbs = [
  {
    title: 'common.page.settings',
    href: '/settings',
  },
  {
    title: 'common.page.brands',
  },
];

const List = () => {
  const { t } = useTranslation();

  const columns: IRestColumnProps[] = useMemo(
    () => [
      {
        name: 'id',
        title: 'ID',
        isDefault: true,
        render: (dt, rc: DynamicObjectType) => (
          <Link
            className="text-highlight"
            to={`/settings/chainStores/${rc?.id}/edit`}
          >{`${dt}`}</Link>
        ),
      },
      {
        name: 'name',
        title: t('chainStores.name'),
        isDefault: true,
      },
      {
        name: 'isActive',
        title: t('chainStores.isActive'),
        isDefault: true,
        render: (dt) => (
          <Tag color={ACTIVE_STATUS?.find((e) => e.value === dt)?.color}>
            {ACTIVE_STATUS?.find((e) => e.value === dt)?.text}
          </Tag>
        ),
      },
    ],
    [],
  );

  return (
    <RestList
      columns={columns}
      model="chainStores"
      breadcrumbs={breadcrumbs}
      hasSearch
      hasImport={false}
      hasExport={false}
      hasFilter
      hasCustomLayout={false}
      searchKeys={['id', 'name']}
      placeholderInputSearch="Search by ID, name"
    />
  );
};

export default List;
